'use client';

import { createContext, useContext } from 'react';
import { Currency } from 'utils/Currency';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

export interface RegionLocaleContextType {
  region: string;
  language: string;
  locale: string;
  store: ShopifyStore;
  currency: Currency;
  regionSlug: string;
  flag: string | null;
  countryName: string | null;
  detectedRegionFromGeoIP: string;
  /** IP province or state from `x-vercel-ip-country-region`. `XX` means missing. */
  geoRegion: string;
  city: string;
  latitude: string | null;
  longitude: string | null;
  /** Stamped per request so SSR and hydration resolve campaigns identically. */
  serverNow: number;
}

export const RegionLocaleContext = createContext<RegionLocaleContextType>({
  region: 'US',
  language: 'en',
  locale: 'en-US',
  store: ShopifyStore.US,
  currency: Currency.usd,
  regionSlug: 'us',
  flag: null,
  countryName: null,
  detectedRegionFromGeoIP: 'XX',
  geoRegion: 'XX',
  city: 'XX',
  latitude: null,
  longitude: null,
  serverNow: 0,
});

export function useRegionLocale(): RegionLocaleContextType {
  return useContext(RegionLocaleContext);
}
